import { PaymentStatus, Money } from "./Types";

export const generatePaymentSummaryUrl = (
  status: PaymentStatus,
  discount: number,
  referenceId: string | undefined,
  paymentValue: Money | undefined,
  quoteId: string,
  localCurrency?: string
) => {
  const searchParams = new URLSearchParams();
  if (status) {
    searchParams.append("status", status);
  }
  if (referenceId) {
    searchParams.append("referenceId", referenceId);
  }
  if (paymentValue?.amount) {
    searchParams.append("amount", paymentValue.amount.toString());
  }
  if (discount > 0) {
    searchParams.append("discount", discount.toString());
  }
  if (localCurrency) {
    searchParams.append("localCurrency", localCurrency);
  }
  return `/paymentSummary/${quoteId}${searchParams.toString() && "?"}${searchParams.toString()}`;
};
